import React from 'react'
import { Route } from 'react-router'
import config from 'config/routes'
import { MyGousto } from './MyGousto'

export const MyGoustoRoute = (
  <Route path={config.client.myGousto} component={MyGousto} />
)
